export default __webpack_public_path__ + "ad83d76.png";